import React, { ReactNode } from "react";
import { ErrorBoundary, Footer, NavBar } from "../components/layout";
import { WhatsAppButton } from "../components/ui";
import { site, socialLinks, logoSvg, resolveSocialLinks } from "../content/site";

const Layout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const links = resolveSocialLinks(socialLinks);

  return (
    <div className="min-h-screen relative flex flex-col flex-1 isolate">
      <NavBar title={site.title} logo={logoSvg} navigation={site.navigation} socialLinks={links} />
      <main className="relative flex-1">
        <ErrorBoundary>{children}</ErrorBoundary>
        {site.whatsAppUrl && <WhatsAppButton url={site.whatsAppUrl} />}
      </main>
      <Footer title={site.title} logo={logoSvg} copyrightCopy={site.copyrightCopy} socialLinks={links} />
    </div>
  );
};

export default Layout;
